// apps/build/src/lib/lab-data.ts — the Studio's data client (SloeData, D-086)
// supabase-js is used only as the PostgREST client for the Neon Data API (it
// appends /rest/v1). Every request carries the signed-in user's 5-minute
// SloeData token (role authenticated, RLS-filtered) from the Lab BFF — see
// ./sloeAuthClient.ts. Signed out → no token → the Data API refuses (there is
// no anonymous role): anonymous Studio flows go through server routes instead.
// With `accessToken` set, supabase-js turns its auth namespace OFF — identity
// comes from ./auth.tsx (the BFF session), never from this client.
import { createClient } from '@supabase/supabase-js';
import { retryingFetch } from '@sloe/sloedata';
import { getDataToken } from './sloeAuthClient';

const RAW_URL = import.meta.env.VITE_LAB_DATA_API_URL as string | undefined;
// Accept the Data API URL with or without the /rest/v1 suffix.
const dataApiBase = RAW_URL ? RAW_URL.trim().replace(/\/+$/, '').replace(/\/rest\/v1$/, '') : undefined;

// Real client when configured, no-op stub when not (local builds without env).
export const labData = dataApiBase
  ? createClient(dataApiBase, 'sloedata', {
      accessToken: async () => (await getDataToken()) ?? '',
      // 503 PT503 = the request reached Postgres without its JWT identity — retry.
      global: { fetch: retryingFetch() },
    })
  : ({
      from: (_table: string) => ({
        insert: async (_data: any) => ({ error: null }),
        select: async () => ({ data: [], error: null }),
      }),
    } as any);
